export default "__VITE_ASSET__DwuE3z39__"